const appInfo={
    state:{
        appId:'',
        appName:'',
        ak:''
    },
    mutations:{
        setAppInfo(state, response){
            state.appId = response.appId;
            state.appName = response.appName;
        },
        setAKey(state, response){
            state.ak = response.ak;
        }

    }
};

export default appInfo;